import './error.scss'

export default function Error({ children, active }) {
  return <div className={`styled-error ${active ? 'active' : 'inactive'}`}>{children}</div>
}
